import styled from "styled-components";

import { FaCheckSquare } from 'react-icons/fa';

export const PortafolioContainer = styled.section`
    height:auto;
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    background:#111221;
`;
export const PortafolioWrapper = styled.div`
    max-width:1200px;
    margin:0 auto;
    display:grid;
    margin-bottom:5rem;
    grid-template-columns: repeat(4,auto);
    align-items:center;
    grid-gap:1rem;
    @media screen and (max-width:1000px){
        grid-template-columns: repeat(2,auto);
        grid-template-rows: auto auto;
        padding:0px !important;
    }
    @media screen and (max-width:768px){
        grid-template-columns: repeat(2,auto);
        grid-template-rows: auto auto;
    }
`;
export const PortafolioCard = styled.div`
    background:transparent;
    display:flex;
    flex-direction:column;
    justify-content:start;
    align-items:center;
    border-radius: 10px;
    width:18rem;
    padding:30px;
    transition: all 0.2s ease-in-out;
    border: 2px solid #E8175D;
    &:hover{
        transform: scale(1.02);
        transition: all 0.2s ease-in-out;
    }
    @media screen and (max-width:600px){  
      padding:7px;
      width:10rem;
      height:15rem;
    }
`;
export const PortafolioControls = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    padding: 2%;
    margin-top: -3rem;
`;
export const TagButton = styled.button`
    padding: 10px;
    border: none;
    border-radius: 3px;
    background-color: transparent;
    cursor: pointer;
`;
export const PortafolioH2 = styled.h2`
    font-size:2rem;
    font-weight:400 !important;
    color:#E8175D;
    margin-top:10rem;
    margin-bottom:64px;
    @media screen and (max-width:600px){
        font-size:2rem;
        margin-top:4rem;
        margin-bottom:4rem;
    }
`;
export const PortafolioDescription = styled.p`
    color:#fff;
    margin-top:1.5rem;
    margin-bottom:1.5rem;
    text-align:center;
    @media screen and (max-width:600px){
        margin-top:0.5rem;
        margin-bottom:1.5rem;
        font-size:0.8rem;
    }
`;
export const PortafolioH3 = styled.h3`
    text-transform:uppercase;
    font-weight:inherit !important;
`;
export const PortafolioIcon = styled.a`
    font-size:1rem;
    margin-bottom: 10px;
    display:block;
    color:#fff;
    text-decoration:none;
    text-align:center;
    font-weight:bold;
    @media screen and (max-width:600px){
        font-size:0.8rem;
        font-weight:100;
    }
`;
export const PortafolioButtton = styled.a`
    color:#fff;
    background: #000014;
    border-radius: 10px;
    padding:1rem;
    text-decoration:none;
`;
export const Portafolioicono = styled(FaCheckSquare)`
    margin-left:12rem;
    margin-bottom:0.5rem;
    color: ${({strong}) => (strong ? '#E8175D':'transparent' )};
    @media screen and (max-width:600px){
        margin-left:7rem;
    }
`;